import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PromoContextServiceBase } from '../../baseBtl/context/child/promo-context.service';
import { ContextInterfaceBase } from '../../baseBtl/context/context.interface';

/**
 * Created by fruysshaert on 03/05/2017.
 */
import { ContextInterface } from '../context.interface';

@Injectable({
    providedIn: 'root',
})
export class PromoContextService extends PromoContextServiceBase implements ContextInterface {
    public create(): Observable<ContextInterfaceBase> {
        const instance: PromoContextService = new PromoContextService(
            this.oauth2Ressource,
            this.document,
            this.configService,
            this.oauth2Service,
            this.http,
        );
        return instance.config();
    }
}
